module.exports = __webpack_public_path__ + "static/DN_logo-c47499fe3253bed19874666140448428.png";